"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvers = void 0;
const lodash_1 = require("lodash");
const lifeCycleState_1 = __importDefault(require("./lifeCycleState"));
exports.resolvers = lodash_1.merge(lifeCycleState_1.default);
//# sourceMappingURL=index.js.map